<vdr-card title="Store Sites">
    <store-sites-list #storeSitesList [sellerId]="sellerId"></store-sites-list>
</vdr-card>

